import MarketEvolution from '../../../../common/src/sections/home/MarketEvolution';

// Species ID 2 = Cherries (hardcoded for importers app)
const CHERRY_SPECIES_ID = 2;

const MarketEvolutionPage = () => {
  return (
    <MarketEvolution
      forceSpeciesId={CHERRY_SPECIES_ID}
      hideExporterPrice
    />
  );
};

export default MarketEvolutionPage;
